import { makeStyles } from "tss-react/mui";

interface IStyleParams {
    isMobile: boolean;
}

export const useStyle = makeStyles<IStyleParams>()((_theme, { isMobile }) => ({
    retryIconContainer: {
        flex: isMobile ? "unset" : 1,
        minWidth: 0,
        overflow: "hidden",
    },
    retryLink: {
        ...(isMobile && {
            width: "100%",
        }),
    },
}));
